import React from 'react';
import './RichTextViewer.css';

interface RichTextViewerProps {
  content: string;
}

/**
 * Displays HTML content from Tiptap editor
 * Safely renders rich text with proper styling
 */
export const RichTextViewer: React.FC<RichTextViewerProps> = ({ content }) => {
  if (!content || content === '<p></p>') {
    return (
      <div className="rich-text-viewer rich-text-viewer--empty">
        <em>No description provided</em>
      </div>
    );
  }

  return (
    <div
      className="rich-text-viewer"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};
